export const PUBLIC_URL = process.env.PUBLIC_URL;
export const APP_BASE_API_URL = "/api"//process.env.REACT_APP_API_URL; 
export const APP_WEB_URL = window.location.origin;// process.env.REACT_APP_WEB_URL;
export const APPLICATION_INSIGHT_I_KEY = process.env.REACT_APP_INSTRUMENTATION_KEY;
